<template>
  <v-container fill-height fluid class="background" style="max-height: 100vh;">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md3>
        <v-card height="300px" class="elevation-12">
          <v-toolbar color="#000000">
            <v-toolbar-title class="white--text"
              >INEGI Energy Metering Platform</v-toolbar-title
            >
            <v-spacer />
            <v-avatar color="tranparent" size="70">
              <img src="../assets/img/inegi_icon.png" />
            </v-avatar>
          </v-toolbar>

          <v-card-title class="card-title">
            <v-icon size="60" color="success" class="pr-4"
              >mdi-account-check</v-icon
            >
            User {{ email }} has been created!</v-card-title
          >
          <v-card-text>
            Awaiting the administrator's approval. You will receive an e-mail
            soon.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: "",
  }),

  created() {
    this.email = this.$route.params.data;
  },

  metaInfo() {
    return {
      title: "INEGI Energy Metering Platform",
    };
  },
};
</script>

<style scoped>
.background {
  background-color: darkgray;
  width: 100%;
  height: 100%;
}
.card-title {
  font-size: 20px;
}
.custom-card {
  height: 300px;
}
</style>
